export default function isPhoto(file: File) {
  if (file.type.includes('image')) {
    return true;
  }
  return false;
}
